import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import NoItemResult from '../../../components/results/NoItemResult';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';

const CompanyEmptyListResult = () => {
    const { t } = useTranslation('companyList');
    const { permissions: accountPermissions } = useAccount();

    // new company link
    const goToNewCompanyPage = useGoTo('/admin/companies/add');

    return (
        <NoItemResult
            extra={
                hasPermissions(accountPermissions, [permissionKind.createCompany]) ? (
                    <Button onClick={goToNewCompanyPage} type="primary">
                        {t('companyList:noData.action')}
                    </Button>
                ) : null
            }
            subTitle={t('companyList:noData.message')}
        />
    );
};

export default CompanyEmptyListResult;
